import { ref } from 'vue'

import { useAppStore } from '@/stores/app'
import type { IClaudeAccount } from '@/types/Auth'

// The Claude accounts the signed-in user keeps. An older plane does not carry the field at
// all, which reads here as "no accounts" — and then nothing about accounts is ever shown.
export const claudeAccounts = (): IClaudeAccount[] => useAppStore().currentUser?.claude_accounts ?? []

// One account is not a choice: the start goes out without asking, and the label is not
// worth a tag on the card either.
export const hasClaudeAccountChoice = (): boolean => claudeAccounts().length > 1

export const defaultClaudeAccount = (): IClaudeAccount | null => {
    const accounts = claudeAccounts()

    return accounts.find(account => account.is_default) ?? accounts[0] ?? null
}

// ---------------------------------------------------------------------------------------
// The "Start with" dialog
// ---------------------------------------------------------------------------------------
//
// A start is written in libs/environment.ts, which has no template of its own, so the one
// dialog lives in the app shell and is opened through this promise. Cancelling resolves to
// null, and a start that was cancelled is simply not sent.

export const claudeAccountPickerOpen = ref(false)

let resolver: ((id: string | null) => void) | null = null

export const resolveClaudeAccountPick = (id: string | null) => {
    claudeAccountPickerOpen.value = false

    if (!resolver) return

    const resolve = resolver
    resolver = null
    resolve(id)
}

export const pickClaudeAccount = (): Promise<string | null> => {
    // A second opening would orphan the first promise, so it is answered first.
    resolveClaudeAccountPick(null)

    claudeAccountPickerOpen.value = true

    return new Promise<string | null>((resolve) => { resolver = resolve })
}
